import React from "react";
import { OrganisationOUT } from "api-client";
import clsx from "clsx";
import Tooltip from "components/Tooltip";
import OrganisationLogo from "features/Organisation/components/OrganisationLogo";
import CountOfBuildings from "./CountOfBuildings";

const OrganisationDetails = (props: {
  organisation?: OrganisationOUT;
  buildingsCount?: number;
  containerClassName?: string;
  nameClassName?: string;
  logoClassName?: string;
  isAsset?: boolean;
  isMenuOpen?: boolean;
  countClassName?: string;
}) => {
  return (
    <div
      className={clsx(
        "flex items-center w-full px-4 pt-4",
        props.containerClassName
      )}
    >
      <OrganisationLogo
        organisation={props.organisation}
        className={clsx("!w-16 !h-16", props.logoClassName)}
      />
      <div className="pl-2 whitespace-nowrap h-10 flex flex-col justify-center">
        <Tooltip
          truncate
          className={clsx(
            "cursor-auto max-w-[200px] font-semibold text-base leading-6",
            props.nameClassName,
            props.isMenuOpen ? "text-indigo-700" : "text-gray-700"
          )}
        >
          {props.organisation?.name}
        </Tooltip>
        <CountOfBuildings
          isAsset={props.isAsset}
          buildingsCount={props.buildingsCount}
          className={props.countClassName}
        />
      </div>
    </div>
  );
};

export default OrganisationDetails;
